import { useQuery } from "@tanstack/react-query"

import type { TrustedSourceResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getTrustedSources(): Promise<TrustedSourceResponse> {
  return api.get("/trusted-sources")
}

export function useGetTrustedSources() {
  const sourcesQuery = useQuery({
    queryKey: queryKeys.trustedSources,
    queryFn: () => getTrustedSources(),
    enabled: true,
  })

  return sourcesQuery
}
